import { createPendingQueueStore } from '../lib/pendingQueue.js';
import type { EmittedReview } from './sessionReducer.js';

/**
 * Offline buffer for flashcard reviews + session completions.
 *
 * Unlike lesson completions (enqueued only on error), reviews are ALWAYS
 * enqueued and drained by the flusher: `apply_flashcard_reviews` is
 * replay-idempotent per client_id, so double-sends are harmless and the
 * grade → persist path has no race window. Sessions mirror the lesson
 * pattern (direct RPC, enqueue on error) since they're idempotent per
 * session_id too.
 */

export interface PendingReview extends EmittedReview {
  client_id: string;
  userId: string;
  queuedAt: number;
  attempts?: number;
  lastAttemptAt?: number;
}

export interface PendingSession {
  session_id: string;
  cards: number;
  userId: string;
  queuedAt: number;
  attempts?: number;
  lastAttemptAt?: number;
}

export const usePendingReviewStore = createPendingQueueStore<{
  reviews: PendingReview;
  sessions: PendingSession;
}>({
  storageKey: 'fluent.pending-flashcards.v1',
  collections: {
    reviews: (r) => r.client_id,
    sessions: (s) => s.session_id,
  },
});
